// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
) {
  let timer: NodeJS.Timeout | string | number | undefined

  return (...args: Parameters<T>) => {
    // super edge case, but being explicit for falsey cases
    if (timer !== undefined) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      // eslint-disable-next-line prefer-spread
      func.apply(null, args)
    }, wait)
    return timer
  }
}
